import React from 'react';
import  {IndexLink,Link} from 'react-router';
import * as commonApi from '../../../api/common-api';
import * as courseApi from '../../../api/course-api';
import { connect } from 'react-redux';
import Loading from 'react-loading';
import axios from 'axios';
var querystring = require('querystring');
import Select from 'react-select';
import VirtualizedSelect from 'react-virtualized-select'
import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css'
import ReactDOM from 'react-dom';
import Textarea from 'react-textarea-autosize';

//var termArr = [];
class ProfileCourse extends React.Component{
	constructor(props) {
    super(props);
    
    
var my=false;
if(this.props.user.id_account == this.props.profileId)
{
	my=true;
}
	this.state = {loading:false,profileId:this.props.profileId,my:my,courseOps:[],courseArr:[],courses:[],item:{}};
    //profileId = this.props.profileId;
    //this.getCourses = this.getCourses.bind(this);
  }
  
  


	componentDidMount() {
		
			   axios.get('code/apis.php?api=getCourses&university_id='+this.props.user.university_account)
			    .then(response => {	
			    	if(response.data.status == 1)
			    	{
			    		this.setState({courseOps:response.data.data});
			    		//courseOptions = response.data.data;
			    		
			    		//store.dispatch(getUserSuccess(response.data.data));
			    	}
			    	//console.log(response.data);
			      
			      return response;
			    });
			    this.setState({loading:true},()=>{this.getUserCourses();})
			
			
	}
	componentWillReceiveProps(nextProps) {
		var my=nextProps.my;
		
		var loading = false;
		if(nextProps.profileId!=this.props.profileId)
		{
			loading = true;
		}
		if(loading)
		{
			this.setState({loading:loading,profileId:nextProps.profileId,my:my,courseArr:[],courses:[]},()=>{this.getUserCourses();});
		}
		else {
			this.setState({profileId:nextProps.profileId,my:my});
		}
		
		
		
		//profileId = nextProps.profileId;
		//this.getCourses();
	}
	getUserCourses()
	{
		axios.get(commonApi.getAPIURL()+'?api=getUserCourses&user_id='+this.state.profileId)
			    .then(response => {	
			    	if(response.data.status == 1)
			    	{
			    		var courseArr = [];
			    		var i=0;
			    		for(var item of response.data.data)
			    		{
			    			
							
								
								var style = {};
								if(i==0)
							{
								style = {border:"none"};
							}
								courseArr.push(<div key={"profile-course-item-"+item.id_course} className="item_box" style = {style}>
				<div className="left_item_box">
					<div className="image">	
						<img src="/static/img/appimg/icon_profile_course.png"/>
					</div>
				</div>
				<div className="right_item_box">
					<div className="title2"><Link to={"/course/"+item.id_term_list_course}>{item.code_course+": "}</Link>{item.name_course}</div>
					
					
					
					{this.state.my?(<a onClick={this.removeCourse.bind(this,item)}  className="close_btn"><img src="/static/img/appimg/icon_close_x.png"/></a>
					):""}
				</div>
			</div>);
							i++;
			    		}
			    		
			    		this.setState({courses:response.data.data,courseArr:courseArr});
			    		//store.dispatch(getUserSuccess(response.data.data));
			    	}
			    	this.setState({loading:false});
			    	//console.log(response.data);
			      
			      return response;
			    });
	}
	
	
	
	
   	
 
   	onSelectCourse(item)
   	{
   		var it = this.state.item;
   		
   		it.course=item.value;
   		this.setState({item:it});
   	}
   	
	
   	
  	addClick(e)
  	{
  		this.setState({show:true,item:{}})
  	}
  	save(e)
  	{
  		var item = this.state.item;
  		
  		if(item.course == undefined)
		{
			commonApi.showAlert("Please select course");
			return;
		}
		
		
		
		axios.get('code/apis.php?api=getCurrentTerm')
			    .then(response => {	
			    	if(response.data.status == 1)
			    	{
			    		var term = response.data.data[0];
			    		
			    		
			    		var data = new FormData();
			//data.append('id', item.id);
							data.append('course', item.course);
				          data.append('term', term.value);
				          
				          axios.post(commonApi.getAPIURL()+'?api=updateAccountCourses',data)
						    .then(response => {	
						    	if(response.data.status == 1)
						    	{
						    		this.setState({show:false,item:{}});
						    		
						    			this.getUserCourses();
						    		courseApi.getMyCourses();
						    		
						    		
						    	}
						    	
						    	//console.log(response.data);
						      
						      return response;
						    }).catch(error=> {
				    
				  });
			    		
			    		//store.dispatch(getUserSuccess(response.data.data));
			    	}
			    	//console.log(response.data);
			      
			      return response;
			    });
		
   			
   		}
          
  	
  	cancel(e)
  	{
  		this.setState({show:false,item:{}});
  	}
  	
  	
	removeCourse(it,e)
	{
		var data = new FormData();
			data.append('id', it.id);
			
          axios.post(commonApi.getAPIURL()+'?api=leaveCourse&c_id='+it.id_term_list_course,data)
		    .then(response => {	
		    	if(response.data.status == 1)
		    	{
		    		this.setState({show:false,item:{}});
		    		
		    			this.getUserCourses();
		    		
		    		courseApi.getMyCourses();
		    		
		    	}
		    	
		    	//console.log(response.data);
		      
		      return response;
		    }).catch(error=> {
    
  });
	}
	
	render() {
		// if(this.state.terms == undefined){
			// return (
				// <div className="page_course_box profile_content_wrapper">
						// <div >
							// <div style={{color:"#545454"}}><Loading delay={0} type='spinningBubbles' color='rgba(84, 84, 84, 1)' width="20px" height="20px" /> Loading</div>
						// </div>
// 					
				// </div>
			// );
		// }
		
		
    return (
    	<div className={(this.state.my || this.state.courseArr.length > 0) && this.state.loading == false ?"page_course_box profile_content_wrapper hide-el":"hide-el"}>
	    	<div className="title_box">
	    		<img src="/static/img/appimg/icon_course.png"/>
	    		<div className="title">
	    			Courses
	    		</div>
	    	</div>
	    	{this.state.show?(<div className="edit_box">
				<div className="left_edit_box">
					<div className="image">	
						
					</div>
				</div>
				<div className="right_edit_box">
					
					<div className="edit_item">
						<div className="title">Name</div>
						<div ><VirtualizedSelect
								    value={this.state.item.course}
								    onChange={this.onSelectCourse.bind(this)}
								    placeholder="Course name..."
								    options={this.state.courseOps}
								    clearable={false}
							    	searchable={true}
								/></div>
						
						
					</div>
					
					<div className="edit_item">
						<div className="title"></div>
						<a onClick={this.save.bind(this)} className="btn_v btn_confirm fright">Save</a>
						<a onClick={this.cancel.bind(this)} style={{marginRight:"10px"}} className="btn_v btn_cancel fright">Cancel</a>
						
					</div>
				</div>
			</div>):(<div className={this.state.my?"add_box clickable":"hide-el"} onClick={this.addClick.bind(this)}>
				<div className="left_add_box">
					<img src="/static/img/appimg/icon_add_black.png"/>
				</div>
				<div className="right_add_box">
					<div className="title">Add current courses</div>
					<div className="des"><img src="/static/img/appimg/icon_i.png"/> you can find an example below</div>
				</div>
			</div>)}
			{this.state.courseArr.length == 0&&this.state.loading==false?(<div  className="item_box op07">
				<div className="left_item_box">
					<div className="image">	
						<img src="/static/img/appimg/icon_profile_course.png"/>
					</div>
				</div>
				<div className="right_item_box">
					<div className="title2">ECO 2023: Principles of Microeconomics</div>

				</div>
			</div>):"" }
			
			{this.state.courseArr}

			
		</div>
      
    )
  }
}

export default ProfileCourse;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_course.js
 **/